import { Card } from "~/components/ui/card"
import type { Partner } from "@apps/gwservice/types"
import { RemoteImg } from "~/components/ui/remote-img"

interface Props {
  partner: Partner
}

export function PartnerCarouselCard({ partner }: Props) {
  return (
    <Card className="flex flex-row items-center p-0! w-partner-carousel-card shadow-none ml-m shrink-0">
      {partner.cover && (
        <div className="relative size-group-img shrink-0">
          <RemoteImg src={partner.cover.url} alt={partner.title} className="absolute inset-0 size-full object-cover p-s" />
        </div>
      )}
      <div className="flex-1 p-s pl-0 flex flex-col gap-1 min-w-0">
        <div className="truncate">{partner.title}</div>
        {partner.info && (
          <div className="text-sm text-muted-foreground line-clamp-2 hyphens-auto" lang="ru">{partner.info}</div>
        )}
      </div>
    </Card>
  )
}
